import { IconDot } from './buttons/IconButtons';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 *
 * CustomTimeLineItems Component
 *
 * Renders a vertical timeline item with:
 * - a dot centered vertically
 * - a line above the dot (unless it is the first item)
 * - a line below the dot (unless it is the last item)
 *
 * PROPS:
 * @param {boolean} isFirst  - When true, hides the top line and adjusts dot position.
 * @param {boolean} isLast   - When true, hides the bottom line.
 * @param {string} className - Optional custom classes for the wrapper.
 * @param {ReactNode} children - The content displayed to the right of the timeline.
 */
const CustomTimeLineItems = ({ isLast = false, isFirst = false, className = '', children }) => {
    return (
        <div className={`timeline-items position-relative ${className}`}>
            {!isFirst && <div className='timeline-line timeline-line-top'/>}
            <div className='timeline-dot-wrapper d-flex justify-content-center align-items-center background-general-00'>
                <IconDot className='icon-color-shades-500 w-6px h-6px' />
            </div>

            {!isLast && <div className='timeline-line timeline-line-bottom'/>}

            <div className='timeline-content ml-4'>{children}</div>
        </div>
    );
};
export default CustomTimeLineItems;
